module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Goldie Goldbloom\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("GOLDIE GOLDBLOOM's fiction has appeared in "), _c('I', [_vm._v("StoryQuarterly")]), _vm._v(", "), _c('I', [_vm._v("Narrative")]), _vm._v(", and "), _c('I', [_vm._v("Prairie Schooner")]), _vm._v(". Her stories have been translated into more than ten languages. She lives in Chicago with her eight children.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12An18a/tc-custom/9781429966986.jpg?1737547131226",
      "alt": "This image is the cover for the book Paperbark Shoe"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Paperbark Shoe\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("An isolated woman's life is upended by the arrival of Italian POWs in this “mesmerizing tale” of love and hardship in WWII-era Australia,  (Joanna Scott, author of ")]), _c('i', [_c('b', [_vm._v("Follow Me")])]), _c('b', [_vm._v(").")])]), _c('p', [_c('i', [_vm._v("During the Second World War, thousands of Italian prisoners of war were sent to Australia. After the Italian surrender, many of these exiles were sent, unguarded, to work on isolated farms.")])]), _c('p', [_vm._v("Gin Boyle is an albino, a classically trained pianist, and a woman with a painful past. Disavowed by her wealthy stepfather, her unlikely savior is the farmer Mr. Toad—a little man with a taste for women’s corsets. Together with their two children, they weather the hardship of rural life and the mockery of their neighbors. But with the arrival of two Italian prisoners of war, their lives are turned upside down. ")]), _c('p', [_vm._v("Thousands of miles from home, Antonio and John find themselves on Mr. and Mrs. Toad’s farm, exiles in the company of exiles. "), _c('i', [_vm._v("The Paperbark Shoe")]), _vm._v(" is a remarkable novel about the far-reaching repercussions of war, the subtle violence of displacement, and what it means to live as a captive in enemy country, and in one’s own skin.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0